import React from 'react';
import PageTemplate from '../components/Layout/PageTemplate/PageTemplate';
import CommonList from '../views/CommonTableView';
const HolidayMasterPage = () => {
    return (
        <PageTemplate>
           <CommonList
            page={"holiday_master"}
        />
        </PageTemplate>
    );
};

export default HolidayMasterPage;

